import type { Translation } from "~/types/i18n";

export const zhCn: Translation = {
  nav: {
    top: "TOP",
    pv: "PV",
    introduction: "INTRODUCTION",
    character: "CHARACTER",
    news: "NEWS",
    goods: "GOODS",
    onair: "ON AIR",
    special: "SPECIAL",
  },
  hero: {
    comingSoon: "播出信息即将公开",
    scrollDown: "SCROLL",
  },
  pv: {
    title: "PV",
    subtitle: "宣传视频",
  },
  synopsis: {
    title: "STORY",
    subtitle: "剧情简介",
  },
  characters: {
    title: "CHARACTER",
    subtitle: "角色介绍",
    cv: "声优",
  },
  news: {
    title: "NEWS",
    subtitle: "最新消息",
    new: "NEW",
    noNews: "暂无新闻",
  },
  md: {
    title: "MD",
    subtitle: "官方周边",
    visitStore: "访问商店",
    goBack: "返回",
    viewDetail: "查看详情",
    buyNow: "去购买",
  },
  onair: {
    title: "ON AIR",
    subtitle: "播出信息",
  },
  special: {
    title: "SPECIAL",
    subtitle: "特别内容",
  },
  footer: {
    policy: "隐私政策",
    originals: "Laftel Originals",
    contact: "联系我们",
    share: "分享到X",
    copyright: "© 2025 Laftel Inc. All Rights Reserved.",
  },
  cta: {
    comingSoon: "即将推出",
  },
  home: {
    heroSubtitle: "Laftel打造的原创动画",
    aboutTitle: "Empowering Fans Everywhere",
    aboutDescription:
      "We, Laftel, expand the diversity of the animation ecosystem by integrating production, investment, merchandise, and offline ventures based on subculture IPs.\nImmerse yourself in a new world of content through the captivating stories discovered by Laftel Originals.",
    worksTitle: "原创作品",
    comingSoon: "COMING SOON",
    navAbout: "ABOUT",
    navWorks: "WORKS",
    watchOnYoutube: "在YouTube观看",
  },
};
